export const actionTypes = {
  WW_GENERATE_KEY_REQUEST: 'WW_GENERATE_KEY_REQUEST',
  WW_GENERATE_KEY_SUCCESS: 'WW_GENERATE_KEY_SUCCESS',
  WW_GENERATE_KEY_ERROR: 'WW_GENERATE_KEY_ERROR',
  WW_GENERATE_PASSWORD_REQUEST: 'WW_GENERATE_PASSWORD_REQUEST',
  WW_GENERATE_PASSWORD_SUCCESS: 'WW_GENERATE_PASSWORD_SUCCESS',
  WW_GENERATE_PASSWORD_ERROR: 'WW_GENERATE_PASSWORD_ERROR',
  WW_RESET_KEY_REQUEST: 'WW_RESET_KEY_REQUEST',
  WW_RESET_KEY_SUCCESS: 'WW_RESET_KEY_SUCCESS',
  WW_RESET_KEY_ERROR: 'WW_RESET_KEY_ERROR'
}
